import axios from "axios";

export { importTransportationPriceListActions };
axios.defaults.withCredentials = true;

function importTransportationPriceListActions() {
  const baseUrl = ``;
  const tenantVal = `${process.env.REACT_APP_TENANT}`;
  return {
    getImportTransportationPriceList,
    //getByCodeStatusReasons,
     exportDataImportTransportationPriceList,
    exportFileImportTransportationPriceListDataById,
     exportErrorImportTransportationPriceListDataById,
     getStatus
  };

  async function exportDataImportTransportationPriceList(
    tenant:string|undefined,
    fileName?: String,
    status?: String,
    startDateFrom?: any,
    startDateTo?: any,
    idSupplier? : number
  ) {
    const exportAllDataImportTransportationPriceList = await axios.get(
      
      `${baseUrl}/masterdatatransportation/pricelistfileuploaded/excel`,
      {
        params: {
            tenant:tenant,
            filename: fileName,
            status: status,
            startDateFrom: startDateFrom,
            startDateTo: startDateTo,
            idSupplier: idSupplier
        },
        responseType: "arraybuffer",
        headers: { "Access-Control-Allow-Origin": true },
        //responseType:'stream' || 'blob'
      }
    );

    return exportAllDataImportTransportationPriceList;
  }

  async function getImportTransportationPriceList(
    tenant:string|undefined,
    pageNumber:number,
    pageSize:number,
    fileName?: String,
    status?: String,
    startDateFrom?: any,
    startDateTo?: any,
    idSupplier? : number
  ) {
   
    const getAllImportTransportationPriceList = await axios.get(
      `${baseUrl}/masterdatatransportation/pricelistfileuploaded`,
      {
        params:{
          tenant:tenant,
          pageNumber:pageNumber,
          pageSize:pageSize,
          filename: fileName,
            status: status,
            startDateFrom: startDateFrom,
            startDateTo: startDateTo,
            idSupplier: idSupplier
        }
      }
    );

    return getAllImportTransportationPriceList;
  }

  async function exportFileImportTransportationPriceListDataById( tenant:string|undefined,id?: String) {
    const exportFileById = await axios.get(
       
      `${baseUrl}/masterdatatransportation/pricelistfileuploaded/${id}/file`,
      {
        params:{tenant:tenant},
        responseType: "arraybuffer",
        headers: { "Access-Control-Allow-Origin": true },
        
      }
    );

    return exportFileById;
  }


  async function exportErrorImportTransportationPriceListDataById( tenant:string|undefined,id: String) {
    const exportErrorById = await axios.get(

      `${baseUrl}/masterdatatransportation/pricelistfileuploaded/${id}/errorfile`,
      {
        params:{tenant:tenant},
        responseType: "arraybuffer",
        headers: { "Access-Control-Allow-Origin": true },
      
      }
    );

    return exportErrorById;
  }



  async function getStatus() {
    return new Promise(function (resolve, reject) {
        axios.get(`${baseUrl}/masterdatatransportation/pricelistfileuploaded/status/all`)
        .then(function (status:any) {
            resolve(status);
        });
    });
}
}
